export default __webpack_public_path__ + "static/media/colis-prive.74809f15.svg";